// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"swap"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 14.5H4L9 19.5M3 9.5L20 9.5L15 4.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SwapIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'swap',
    ref,
    icon: element,
  },
));

SwapIcon.displayName = 'SwapIcon';

export default SwapIcon;
